import { render, staticRenderFns } from "./Geofences.vue?vue&type=template&id=655e3da4"
import script from "./Geofences.vue?vue&type=script&lang=js"
export * from "./Geofences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports